import { Navigate, useParams } from 'react-router-dom';

/**
 * Legacy `/preview` route: redirects to the dedicated read-only view page.
 */
const ReportPreviewPage = () => {
  const { reportId = '' } = useParams<{ reportId: string }>();
  return <Navigate to={`/${reportId}/view`} replace />;
};

export default ReportPreviewPage;
